module.exports = __webpack_public_path__ + "static/img/product8.da16ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product8.jpg
// module id = dFAi
// module chunks = 0